module.exports = __webpack_public_path__ + "img/slider-2.8655dcb9.jpg";